import dayjsUtil from 'dayjs';

export const dayjs = dayjsUtil;

export const isNull = (val) => {
	return val === '' || val === undefined || val === null;
}

export const randomColor = () => { //随机生成RGB颜色
	var r = Math.floor(Math.random() * 256); //随机生成256以内r值
	var g = Math.floor(Math.random() * 256); //随机生成256以内g值
	var b = Math.floor(Math.random() * 256); //随机生成256以内b值
	return `rgb(${r},${g},${b})`; //返回rgb(r,g,b)格式颜色
}

export const checkUnitPX = (val) => {
	if (!val) {
		return '0';
	}
	if (val.indexOf('px') == -1 && val.indexOf('%') == -1) {
		return val + 'px';
	}
	return val;
}

export const debounceA = (fn, delay) => {
	let timeoutId
	return function (...args) {
		clearTimeout(timeoutId)
		timeoutId = setTimeout(() => {
			fn.apply(this, args)
		}, delay)
	}
}

export const debounce = (func, wait, immediate) => {
	let timeout, args, context, timestamp, result

	const later = function () {
		const last = +new Date() - timestamp

		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}

	return function (...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

export const trackListChange = (list) => {
	if (!Array.isArray(list) || list.length < 2) return list;

	for (let i = 1; i < list.length; i++) {
		const prev = list[i - 1];
		const curr = list[i];

		const prevLon = parseFloat(prev.lon || prev.lng);
		const currLon = parseFloat(curr.lon || curr.lng);
		const lonDiff = prevLon - currLon;

		if (Math.abs(lonDiff) > 180) {
			const offset = lonDiff > 0 ? 360 : -360;
			if (curr.lon !== undefined) {
				curr.lon = currLon + offset;
			} else {
				curr.lng = currLon + offset;
			}
		}
	}
	return list;
};

export const blobImageDownload = (data, fileName) => {
	let link = document.createElement('a');
	let url = window.URL.createObjectURL(new Blob([data]));
	link.href = url;
	link.download = fileName;
	link.click();
	window.URL.revokeObjectURL(url);
}
